import footerTecnoLogo from "../../resources/images/footer_tecno_logo.png";
import ismsLogo from "../../resources/images/isms-logo.png";
import { Box, Link, SxProps, Theme } from "@mui/material";

export const Footer = () => {
  return (
    <Box sx={sx} className="Footer">
      <Box className="Footer-Main">
        <Box className="Footer-Main-Tecno-Logo" component="img" alt="テクノスタンダード" src={footerTecnoLogo} />
        <Box className="Footer-Main-Post">
          〒150-0002
          <br />
          東京都渋谷区渋谷3-10-15 YKビル7F
        </Box>
        <Box className="Footer-Main-Index">
          <Link className="Footer-Main-Index-Link" href="/#About">
            <Box>ABOUT</Box>
          </Link>
          <Link className="Footer-Main-Index-Link" href="/#Service">
            <Box>SERVICE</Box>
          </Link>
          <Link className="Footer-Main-Index-Link" href="/#Company">
            <Box>COMPANY</Box>
          </Link>
          <Link className="Footer-Main-Index-Link" href="/#Contact">
            <Box>CONTACT</Box>
          </Link>
          <Link className="Footer-Main-Index-Link" href="/recruit">
            <Box>RECRUIT</Box>
          </Link>
          <Link
            className="Footer-Main-Index-Link"
            target="_blank"
            href="/resources/情報セキュリティ基本方針_第1版.pdf"
            rel="noopener noreferrer"
            component="a"
          >
            <Box>情報セキュリティ基本方針</Box>
          </Link>
          <Link
            className="Footer-Main-Index-Link"
            target="_blank"
            href="/resources/テクノスタンダードプライバシーポリシー.pdf"
            rel="noopener noreferrer"
            component="a"
          >
            <Box>プライバシーポリシー</Box>
          </Link>
        </Box>
      </Box>
      <Box className="Footer-Copyright">
        <Box className="Footer-Copyright-Text">© Techno Standard, Inc.</Box>
        <Box className="Footer-Isms-Logo" component="img" alt="ISMSロゴ" src={ismsLogo} />
      </Box>
    </Box>
  );
};

const sx: SxProps<Theme> = (theme) => ({
  "&.Footer": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    overflowX: "hidden",
  },
  ".Footer-Main": {
    background: "#373636",
    color: "#FFFFFF",
    width: "100%",
    boxSizing: "border-box",
  },
  ".Footer-Main-Tecno-Logo": {
    display: "flex",
    justifyContent: "center",
    margin: "0 auto",
    paddingTop: {
      md: "68px",
      xs: "40px",
    },
    maxWidth: {
      md: "auto",
      xs: "200px",
    },
  },
  ".Footer-Main-Post": {
    margin: "16px auto",
    textAlign: "center",
  },
  ".Footer-Main-Index": {
    display: "flex",
    flexDirection: {
      md: "row",
      xs: "column",
    },
    alignItems: "center",
    justifyContent: "center",
    padding: {
      md: "32px 0  64px",
      xs: "48px 0  0",
    },
  },
  ".Footer-Main-Index-Link": {
    color: "#FFFFFF",
    textDecoration: "none",
    border: {
      md: "none",
      xs: "1px solid rgba(247, 248, 248, 0.3)",
    },
    width: {
      md: "auto",
      xs: "100%",
    },
    textAlign: "center",
    margin: {
      md: "0px 28px",
    },
    padding: {
      md: "0",
      xs: "24px 0",
    },
    "&:hover": {
      cursor: "pointer",
    },
  },
  ".Footer-Copyright": {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    flexDirection: "column",
    margin: "20px auto",
  },
  ".Footer-Copyright-Text": {
    fontSize: "15px",
    lineHeight: "20px",
    fontWeight: 400,
    textAlign: "center",
  },
  ".Footer-Isms-Logo": {
    margin: "0 auto",
    maxWidth: "200px",
  },
});
